import { OptionType } from "@covertree/types";
export interface Lender {
  name: string;
  streetAddress: string;
  unit?: string | null;
  city: string;
  state: string;
  zip: string;
  email?: string | null;
}

/**
 * Keyed by dropdown label. The label equals `name` except where one lender
 * mails from several addresses: those labels carry the city so agents can tell
 * them apart, while `name` stays the name printed on the policy.
 */
export const lenders: Record<string, Lender> = {
  "21ST MORTGAGE CORPORATION": {
    name: "21ST MORTGAGE CORPORATION",
    streetAddress: "Po Box 477",
    unit: null,
    city: "Knoxville",
    state: "TN",
    zip: "37901",
  },
  "A+ FCU  (AUSTIN AREA TEACHERS)": {
    name: "A+ FCU  (AUSTIN AREA TEACHERS)",
    streetAddress: "Po Box 15384",
    unit: null,
    city: "Austin",
    state: "TX",
    zip: "787615384",
  },
  "ACADEMY MORTGAGE CORP.": {
    name: "ACADEMY MORTGAGE CORP.",
    streetAddress: "339 West 13490 South",
    unit: null,
    city: "Draper",
    state: "UT",
    zip: "84020",
  },
  "ADVANCIAL FEDERAL CREDIT UNION": {
    name: "ADVANCIAL FEDERAL CREDIT UNION",
    streetAddress: "P.o. Box 27611",
    unit: null,
    city: "Sacramento",
    state: "CA",
    zip: "958276711",
  },
  "AEA FEDERAL CREDIT UNION ITS  SUCCESSORSS & /OR A": {
    name: "AEA FEDERAL CREDIT UNION ITS  SUCCESSORSS & /OR A",
    streetAddress: "Po Box 15010",
    unit: null,
    city: "Lenexa",
    state: "KS",
    zip: "662855010",
  },
  "ALAMO MANUFACTURED HOMES": {
    name: "ALAMO MANUFACTURED HOMES",
    streetAddress: "P.o. Box 3666",
    unit: null,
    city: "Conroe",
    state: "TX",
    zip: "77305",
  },
  AMCAP: {
    name: "AMCAP",
    streetAddress: "9999 Bellaire Blvd #700",
    unit: null,
    city: "Houston",
    state: "TX",
    zip: "77036",
  },
  "AMCAP MORTGAGE LTD ISAOA ATIMA C-O CENTRAL LOAN ADMINISTRATION  REPORT": {
    name: "AMCAP MORTGAGE LTD ISAOA ATIMA C-O CENTRAL LOAN ADMINISTRATION  REPORT",
    streetAddress: "Po Box 202028",
    unit: null,
    city: "Florence",
    state: "SC",
    zip: "29502",
  },
  "AMERICAN FINANCIAL RESOURCES INC ISAOA": {
    name: "AMERICAN FINANCIAL RESOURCES INC ISAOA",
    streetAddress: "9 Sylvan Way",
    unit: null,
    city: "Parsippany",
    state: "NJ",
    zip: "70543816",
  },
  "AMERICAN FINANCIAL RESOURCES ISAOA/ ATIMA": {
    name: "AMERICAN FINANCIAL RESOURCES ISAOA/ ATIMA",
    streetAddress: "Po Box 202049",
    unit: null,
    city: "Florence",
    state: "SC",
    zip: "29502",
  },
  "AMERICAN PACIFIC MORTGAGE CORP ISAOA": {
    name: "AMERICAN PACIFIC MORTGAGE CORP ISAOA",
    streetAddress: "3000 Lava Ridge Ct Ste200",
    unit: null,
    city: "Roseville",
    state: "CA",
    zip: "95661",
  },
  AMERIFIRST: {
    name: "AMERIFIRST",
    streetAddress: "Po Box 7115",
    unit: null,
    city: "Troy",
    state: "MI",
    zip: "480077115",
  },
  "ANGELINA MANUFACTURED HOUSING": {
    name: "ANGELINA MANUFACTURED HOUSING",
    streetAddress: "3907 N Medford Dr",
    unit: null,
    city: "Lufkin",
    state: "TX",
    zip: "759011465",
  },
  "ARVEST CENTRAL MORTGAGE COMPANY": {
    name: "ARVEST CENTRAL MORTGAGE COMPANY",
    streetAddress: "P.o Box 961243",
    unit: null,
    city: "Fort Worth",
    state: "TX",
    zip: "76161",
  },
  "ASSURANCE FINANCIAL GROUP, LLC ISAOA/ATIMA": {
    name: "ASSURANCE FINANCIAL GROUP, LLC ISAOA/ATIMA",
    streetAddress: "9029 Jefferson Hwy. Suite 100",
    unit: null,
    city: "Baton Rouge",
    state: "LA",
    zip: "70809",
  },
  BANCFIRST: {
    name: "BANCFIRST",
    streetAddress: "Po Box 248891",
    unit: null,
    city: "Oklahoma city",
    state: "OK",
    zip: "731248891",
  },
  "BANK OF AMERICA, NA ITS SUCCESSORSS &/OR ASSIGNEES": {
    name: "BANK OF AMERICA, NA ITS SUCCESSORSS &/OR ASSIGNEES",
    streetAddress: "Po Box 961291",
    unit: null,
    city: "Fort Worth",
    state: "TX",
    zip: "76161",
  },
  "BANK OF HOLLAND": {
    name: "BANK OF HOLLAND",
    streetAddress: "12 S Main St",
    unit: "Po Box 9",
    city: "Holland",
    state: "NY",
    zip: "14080",
  },
  "BANK OF LANDISBURG": {
    name: "BANK OF LANDISBURG",
    streetAddress: "Po Box 38",
    unit: "2784 Keystone Way",
    city: "Newport",
    state: "PA",
    zip: "17074",
  },
  "BANK OF OKLAHOMA": {
    name: "BANK OF OKLAHOMA",
    streetAddress: "Po Box 1550",
    unit: null,
    city: "Springfield",
    state: "OH",
    zip: "45501",
  },
  "BANK OF ROMNEY": {
    name: "BANK OF ROMNEY",
    streetAddress: "P.o. Box 876",
    unit: null,
    city: "Romney",
    state: "WV",
    zip: "26757",
  },
  "BAY EQUITY HOME LOANS": {
    name: "BAY EQUITY HOME LOANS",
    streetAddress: "Po Box 29411",
    unit: null,
    city: "Phoenix",
    state: "AZ",
    zip: "85038",
  },
  "BAYCOAST BANK": {
    name: "BAYCOAST BANK",
    streetAddress: "Po Box 4108",
    unit: null,
    city: "Carmel",
    state: "IN",
    zip: "46082",
  },
  "BB&T": {
    name: "BB&T",
    streetAddress: "P.o. Box 7933",
    unit: null,
    city: "Springfield",
    state: "OH",
    zip: "45501",
  },
  "BMO HARRIS BANK": {
    name: "BMO HARRIS BANK",
    streetAddress: "Po Box 961292",
    unit: null,
    city: "Fort Worth",
    state: "TX",
    zip: "76161",
  },
  "BRANCH BANKING & TRUST": {
    name: "BRANCH BANKING & TRUST",
    streetAddress: "Po Box 7933",
    unit: null,
    city: "Springfield",
    state: "OH",
    zip: "45501",
  },
  "BRANCH BANKING & TRUST CO OF VA": {
    name: "BRANCH BANKING & TRUST CO OF VA",
    streetAddress: "P O Box 25610-c",
    unit: null,
    city: "Charlotte",
    state: "NC",
    zip: "28229",
  },
  "BROKER SOLUTIONS, INC. D/B/A NEW AMERICAN FUNDING ISAOA / ATIMA": {
    name: "BROKER SOLUTIONS, INC. D/B/A NEW AMERICAN FUNDING ISAOA / ATIMA",
    streetAddress: "Po Box 5071",
    unit: null,
    city: "Troy",
    state: "MI",
    zip: "480075071",
  },
  "BSI FINANCIAL": {
    name: "BSI FINANCIAL",
    streetAddress: "Po Box 961260",
    unit: null,
    city: "Fort Worth",
    state: "TX",
    zip: "76161",
  },
  "CALHOUN BANKS": {
    name: "CALHOUN BANKS",
    streetAddress: "Po Box 430",
    unit: null,
    city: "Grantsville",
    state: "WV",
    zip: "26147",
  },
  "CALIBER HOME LOANS": {
    name: "CALIBER HOME LOANS",
    streetAddress: "Po Box 7731",
    unit: null,
    city: "Springfield",
    state: "OH",
    zip: "45501",
  },
  "CALIBER HOME LOANS INC ISAOA ATIMA": {
    name: "CALIBER HOME LOANS INC ISAOA ATIMA",
    streetAddress: "Po Box 7731",
    unit: null,
    city: "Springfield",
    state: "OH",
    zip: "455017731",
  },
  "CAPON VALLEY BANK": {
    name: "CAPON VALLEY BANK",
    streetAddress: "Po Box 119",
    unit: null,
    city: "Wardensville",
    state: "WV",
    zip: "26851",
  },
  "CARDINAL FINANCIAL COMPANY": {
    name: "CARDINAL FINANCIAL COMPANY",
    streetAddress: "Po Box 961292",
    unit: null,
    city: "Fort Worth",
    state: "TX",
    zip: "761610292",
  },
  "CARDINAL FINANCIAL COMPANY, LIMITED PARTNERSHIP ISAOA/ATIMA": {
    name: "CARDINAL FINANCIAL COMPANY, LIMITED PARTNERSHIP ISAOA/ATIMA",
    streetAddress: "PO Box 29411",
    unit: null,
    city: "Phoenix",
    state: "AZ",
    zip: "85038",
  },
  "CARRINGTON MORTGAGE SERVICES": {
    name: "CARRINGTON MORTGAGE SERVICES",
    streetAddress: "Po Box 692408",
    unit: null,
    city: "San Antonio",
    state: "TX",
    zip: "782692408",
  },
  "CARRINGTON MORTGAGE SERVICES, LLC": {
    name: "CARRINGTON MORTGAGE SERVICES, LLC",
    streetAddress: "PO Box 692408",
    unit: null,
    city: "San Antonio",
    state: "TX",
    zip: "78269",
  },
  "CARRINGTON MORTGAGE SERVICES, LLC ISAOA/ATIMA": {
    name: "CARRINGTON MORTGAGE SERVICES, LLC ISAOA/ATIMA",
    streetAddress: "PO Box 692408",
    unit: null,
    city: "San Antonio",
    state: "TX",
    zip: "78269",
  },
  "CARROL BANK OF TRUST": {
    name: "CARROL BANK OF TRUST",
    streetAddress: "P.o. Box 1029",
    unit: null,
    city: "Camden",
    state: "TN",
    zip: "383201029",
  },
  "CARROLL BANK & TRUST": {
    name: "CARROLL BANK & TRUST",
    streetAddress: "Po Box 889",
    unit: null,
    city: "Huntingdon",
    state: "TN",
    zip: "383440889",
  },
  "CASCADE FINANCIAL SERVICES, ISAOA": {
    name: "CASCADE FINANCIAL SERVICES, ISAOA",
    streetAddress: "PO Box 961037",
    unit: null,
    city: "Fort Worth",
    state: "TX",
    zip: "76161",
  },
  CELINK: {
    name: "CELINK",
    streetAddress: "Po Box 39457",
    unit: null,
    city: "Solon",
    state: "OH",
    zip: "441390457",
  },
  "CENTIER BANK": {
    name: "CENTIER BANK",
    streetAddress: "600 E 84th Ave",
    unit: null,
    city: "Merrillville",
    state: "IN",
    zip: "46410",
  },
  "CENTRAL LOAN ADMINISTRATION & REPORTING ISAOA, ATIMA": {
    name: "CENTRAL LOAN ADMINISTRATION & REPORTING ISAOA, ATIMA",
    streetAddress: "Po Box 202028",
    unit: null,
    city: "Florence",
    state: "SC",
    zip: "29502",
  },
  "CHAMPION MORTGAGE": {
    name: "CHAMPION MORTGAGE",
    streetAddress: "Po Box 692399",
    unit: null,
    city: "San Antonio",
    state: "TX",
    zip: "78269",
  },
  CITIMORTGAGE: {
    name: "CITIMORTGAGE",
    streetAddress: "Po Box 7706",
    unit: null,
    city: "Springfield",
    state: "OH",
    zip: "45501",
  },
  "CITIZENS & NORTHERN BANK": {
    name: "CITIZENS & NORTHERN BANK",
    streetAddress: "90 Main St",
    unit: null,
    city: "Wellsboro,",
    state: "PA",
    zip: "16901",
  },
  "CITIZENS NATIONAL BANK": {
    name: "CITIZENS NATIONAL BANK",
    streetAddress: "620 Broadway St",
    unit: null,
    city: "Paintsville",
    state: "KY",
    zip: "412401366",
  },
  "CITIZENS TRI COUNTY BANK": {
    name: "CITIZENS TRI COUNTY BANK",
    streetAddress: "Po Box 697",
    unit: null,
    city: "Dunlap",
    state: "TN",
    zip: "37327",
  },
  "CITY NATIONAL BANK": {
    name: "CITY NATIONAL BANK",
    streetAddress: "Po Box 7899",
    unit: null,
    city: "Cross Lanes",
    state: "WV",
    zip: "25356",
  },
  "CLEAR MOUNTAIN BANK": {
    name: "CLEAR MOUNTAIN BANK",
    streetAddress: "Po Box 205",
    unit: null,
    city: "Bruceton Mills",
    state: "WV",
    zip: "265250205",
  },
  "CMG MORTGAGE INC": {
    name: "CMG MORTGAGE INC",
    streetAddress: "P.o. Box 202028",
    unit: null,
    city: "Florence",
    state: "SC",
    zip: "295022028",
  },
  "COLONIAL SAVINGS, FA": {
    name: "COLONIAL SAVINGS, FA",
    streetAddress: "Po Box 2988 Dept 054",
    unit: null,
    city: "Fort Worth",
    state: "TX",
    zip: "76113",
  },
  "COMMUNITY BANK": {
    name: "COMMUNITY BANK",
    streetAddress: "Po Box 2232",
    unit: null,
    city: "Longview",
    state: "TX",
    zip: "756062232",
  },
  "COMMUNITY BANK NA": {
    name: "COMMUNITY BANK NA",
    streetAddress: "Po Box 688",
    unit: null,
    city: "Olean",
    state: "NY",
    zip: "14760",
  },
  "COMMUNITY LOAN SERVICING": {
    name: "COMMUNITY LOAN SERVICING",
    streetAddress: "Po Box 5933",
    unit: null,
    city: "Troy",
    state: "MI",
    zip: "48084",
  },
  "COMMUNITY STATE BANK": {
    name: "COMMUNITY STATE BANK",
    streetAddress: "Po Box 8",
    unit: null,
    city: "Orbisonia",
    state: "PA",
    zip: "17243",
  },
  "CORNING FEDERAL CREDIT UNION": {
    name: "CORNING FEDERAL CREDIT UNION",
    streetAddress: "Po Box 1450",
    unit: "1 Credit Union Plaza",
    city: "Corning",
    state: "NY",
    zip: "14830",
  },
  "COUNTRY PLACE MORTGAGE": {
    name: "COUNTRY PLACE MORTGAGE",
    streetAddress: "Po Box 398014",
    unit: null,
    city: "Minneapolis",
    state: "MN",
    zip: "554398014",
  },
  "COUNTY NATIONAL BANK": {
    name: "COUNTY NATIONAL BANK",
    streetAddress: "Po Box 42",
    unit: "31 South Second Street",
    city: "Clearfield",
    state: "PA",
    zip: "16830",
  },
  "CREDIT HUMAN": {
    name: "CREDIT HUMAN",
    streetAddress: "PO Box 519",
    unit: null,
    city: "Carmel",
    state: "IN",
    zip: "46082",
  },
  "CREDIT HUMAN FEDERAL CREDIT UNION ITS SUCCESSORSS A": {
    name: "CREDIT HUMAN FEDERAL CREDIT UNION ITS SUCCESSORSS A",
    streetAddress: "Po Box 758",
    unit: null,
    city: "San Antonio",
    state: "TX",
    zip: "782930758",
  },
  "CROSS COUNTRY MORTGAGE": {
    name: "CROSS COUNTRY MORTGAGE",
    streetAddress: "6850 Miller Road",
    unit: null,
    city: "Brecksville",
    state: "OH",
    zip: "44141",
  },
  "CROSSCOUNTRY MORTGAGE, LLC ITS SUCCESSORS AND/OR ASSIGNS": {
    name: "CROSSCOUNTRY MORTGAGE, LLC ITS SUCCESSORS AND/OR ASSIGNS",
    streetAddress: "PO Box 7729",
    unit: null,
    city: "Springfield",
    state: "OH",
    zip: "45501",
  },
  "CSL FINANCIAL ISAOA/": {
    name: "CSL FINANCIAL ISAOA/",
    streetAddress: "P.o. Box 661527",
    unit: null,
    city: "Birmingham",
    state: "AL",
    zip: "35266",
  },
  "CU MEMBERS MORTGAGE": {
    name: "CU MEMBERS MORTGAGE",
    streetAddress: "P O Box 961019",
    unit: null,
    city: "Fort Worth",
    state: "TX",
    zip: "761617616",
  },
  "DANNEMORA FCU ISAOA": {
    name: "DANNEMORA FCU ISAOA",
    streetAddress: "344 Tom Miller Rd",
    unit: null,
    city: "Plattsburgh",
    state: "NY",
    zip: "12901",
  },
  "DESERT FINANCIAL FCU": {
    name: "DESERT FINANCIAL FCU",
    streetAddress: "Po Box 2130",
    unit: null,
    city: "Sioux city",
    state: "IA",
    zip: "511040130",
  },
  "DEVONIAN ACQUISITIONS LLC": {
    name: "DEVONIAN ACQUISITIONS LLC",
    streetAddress: "Po Box 7047",
    unit: null,
    city: "Bryan",
    state: "TX",
    zip: "77805",
  },
  "DITECH FINANCIAL LLC ISAOA": {
    name: "DITECH FINANCIAL LLC ISAOA",
    streetAddress: "P.o. Box 979282",
    unit: null,
    city: "Miami",
    state: "FL",
    zip: "33197",
  },
  "DOVENMUEHLE MORTGAGE": {
    name: "DOVENMUEHLE MORTGAGE",
    streetAddress: "Po Box 961292",
    unit: null,
    city: "Fort Worth",
    state: "TX",
    zip: "761610292",
  },
  "EAGLE ONE LLC": {
    name: "EAGLE ONE LLC",
    streetAddress: "6100 S Shields Blvd",
    unit: null,
    city: "Oklahoma city",
    state: "OK",
    zip: "73149",
  },
  "ESSEX MORTGAGE": {
    name: "ESSEX MORTGAGE",
    streetAddress: "1417 North Magnolia Avenue",
    unit: null,
    city: "Ocala",
    state: "FL",
    zip: "34475",
  },
  "ESSEX MORTGAGE ISAOA/ATIMA": {
    name: "ESSEX MORTGAGE ISAOA/ATIMA",
    streetAddress: "PO Box 391313",
    unit: null,
    city: "Solon",
    state: "OH",
    zip: "44139",
  },
  "EVERETT FINANCIAL, INC. ISAOA / ATIMA": {
    name: "EVERETT FINANCIAL, INC. ISAOA / ATIMA",
    streetAddress: "P.o. Box 7057",
    unit: null,
    city: "Troy",
    state: "MI",
    zip: "48007",
  },
  "FAIRWAY INDEPENDENT MORTGAGE CORPORATION": {
    name: "FAIRWAY INDEPENDENT MORTGAGE CORPORATION",
    streetAddress: "4201 Marsh Lane",
    unit: null,
    city: "Carrollton",
    state: "TX",
    zip: "75007",
  },
  "FARMERS BANK": {
    name: "FARMERS BANK",
    streetAddress: "211 West Second Street",
    unit: null,
    city: "Pomeroy",
    state: "OH",
    zip: "45769",
  },
  "FARMERS MERCHANTS BANK & TRUST COMPANY ISAOA/ATIMA": {
    name: "FARMERS MERCHANTS BANK & TRUST COMPANY ISAOA/ATIMA",
    streetAddress: "100 South Main Street",
    unit: null,
    city: "Breaux Bridge",
    state: "LA",
    zip: "70517",
  },
  "FAY SERVICING": {
    name: "FAY SERVICING",
    streetAddress: "Po Box 3644",
    unit: null,
    city: "Springfield",
    state: "OH",
    zip: "455013644",
  },
  "FEDERAL INVESTORS SERVICING CORP": {
    name: "FEDERAL INVESTORS SERVICING CORP",
    streetAddress: "Po Box 749",
    unit: null,
    city: "Levelland",
    state: "TX",
    zip: "793360749",
  },
  "FIDELITY SAVINGS BANK": {
    name: "FIDELITY SAVINGS BANK",
    streetAddress: "Po Box 1007",
    unit: null,
    city: "Wichita",
    state: "KS",
    zip: "67201",
  },
  "FIRST CITIZENS COMMUNITY BANK": {
    name: "FIRST CITIZENS COMMUNITY BANK",
    streetAddress: "1163 S Main St",
    unit: null,
    city: "Mansfield",
    state: "PA",
    zip: "169339537",
  },
  "FIRST COMMONWEALTH BANK": {
    name: "FIRST COMMONWEALTH BANK",
    streetAddress: "Po Box 400",
    unit: null,
    city: "Indiana",
    state: "PA",
    zip: "15701",
  },
  "FIRST COMMUNITY BANK": {
    name: "FIRST COMMUNITY BANK",
    streetAddress: "Po Box 3068",
    unit: null,
    city: "Bluefield",
    state: "WV",
    zip: "24701",
  },
  "FIRST EXCHANGE BANK": {
    name: "FIRST EXCHANGE BANK",
    streetAddress: "Po Box 388",
    unit: null,
    city: "Mannington",
    state: "WV",
    zip: "26582",
  },
  "FIRST FINANCIAL BANK NA": {
    name: "FIRST FINANCIAL BANK NA",
    streetAddress: "Po Box 2559",
    unit: null,
    city: "Abilene",
    state: "TX",
    zip: "79604",
  },
  "FIRST NATIONAL ACCEPTANCE CO ISAOA, ATIMA": {
    name: "FIRST NATIONAL ACCEPTANCE CO ISAOA, ATIMA",
    streetAddress: "Po Box 980",
    unit: null,
    city: "East Lansing",
    state: "MI",
    zip: "488260980",
  },
  "FIRST NATIONAL BANK & TRUST": {
    name: "FIRST NATIONAL BANK & TRUST",
    streetAddress: "Po Box 669",
    unit: null,
    city: "Elk city",
    state: "OK",
    zip: "73648",
  },
  "FIRST NATIONAL BANK OF GROTON": {
    name: "FIRST NATIONAL BANK OF GROTON",
    streetAddress: "161 Main St.",
    unit: null,
    city: "Groton",
    state: "NY",
    zip: "13073",
  },
  "FIRST NATIONAL BANK OF PA": {
    name: "FIRST NATIONAL BANK OF PA",
    streetAddress: "Po Box 703809",
    unit: null,
    city: "Dallas",
    state: "TX",
    zip: "753703809",
  },
  "FIRST NIAGARA BANK": {
    name: "FIRST NIAGARA BANK",
    streetAddress: "Po Box 790790",
    unit: null,
    city: "San Antonio",
    state: "TX",
    zip: "78279-079",
  },
  "FIRST SHORE FEDERAL SAVINGS & LOAN": {
    name: "FIRST SHORE FEDERAL SAVINGS & LOAN",
    streetAddress: "Po Box 4248",
    unit: null,
    city: "Salisbury",
    state: "MD",
    zip: "21803",
  },
  "FIRST UNITED BANK": {
    name: "FIRST UNITED BANK",
    streetAddress: "12894 Garrett Hwy",
    unit: null,
    city: "Oakland",
    state: "MD",
    zip: "21550",
  },
  FIRSTBANK: {
    name: "FIRSTBANK",
    streetAddress: "Po Box 1639",
    unit: null,
    city: "Lexington",
    state: "TN",
    zip: "38351",
  },
  "FLAGSTAR BANK ISAOA ATIMA": {
    name: "FLAGSTAR BANK ISAOA ATIMA",
    streetAddress: "Po Box 52198",
    unit: null,
    city: "Phoenix",
    state: "AZ",
    zip: "850722198",
  },
  "FREEDOM MORTGAGE CORPORATION ISAOA/ATIMA": {
    name: "FREEDOM MORTGAGE CORPORATION ISAOA/ATIMA",
    streetAddress: "Po Box 5050",
    unit: null,
    city: "Troy",
    state: "MI",
    zip: "480075050",
  },
  "FULTON BANK NA": {
    name: "FULTON BANK NA",
    streetAddress: "Po Box 200058",
    unit: null,
    city: "Kennesaw",
    state: "GA",
    zip: "301569246",
  },
  "GATEWAY MORTGAGE GROUP, A DIVISION OF GATEWAY FIRST BANK ISAOA / ATIMA": {
    name: "GATEWAY MORTGAGE GROUP, A DIVISION OF GATEWAY FIRST BANK ISAOA / ATIMA",
    streetAddress: "Po Box 5013",
    unit: null,
    city: "Troy",
    state: "MI",
    zip: "480075013",
  },
  "GRANT COUNTY BANK": {
    name: "GRANT COUNTY BANK",
    streetAddress: "P.o. Box 929",
    unit: null,
    city: "Petersburg",
    state: "WV",
    zip: "26847",
  },
  "GRASSY VALLEY HOMES": {
    name: "GRASSY VALLEY HOMES",
    streetAddress: "Po Box 3416",
    unit: null,
    city: "Johnson city",
    state: "TN",
    zip: "376053416",
  },
  "GREENWOOD CREDIT UNION": {
    name: "GREENWOOD CREDIT UNION",
    streetAddress: "Po Box 150",
    unit: null,
    city: "Northville",
    state: "NY",
    zip: "12134",
  },
  "GUILD MORTGAGE CO  ISAOA": {
    name: "GUILD MORTGAGE CO  ISAOA",
    streetAddress: "Po Box 85304",
    unit: null,
    city: "San Diego",
    state: "CA",
    zip: "92186",
  },
  "GUILD MORTGAGE COMPANY": {
    name: "GUILD MORTGAGE COMPANY",
    streetAddress: "P.o. Box 818009",
    unit: null,
    city: "Cleveland",
    state: "OH",
    zip: "44181",
  },
  "GUILD MORTGAGE COMPANY LLC SUCCESSORS/ASSIGNEES": {
    name: "GUILD MORTGAGE COMPANY LLC SUCCESSORS/ASSIGNEES",
    streetAddress: "PO Box 1788",
    unit: null,
    city: "Springfield",
    state: "OH",
    zip: "45501",
  },
  "GUILD MORTGAGE COMPANY, LLC ISAOA/ATIMA": {
    name: "GUILD MORTGAGE COMPANY, LLC ISAOA/ATIMA",
    streetAddress: "PO Box 1788",
    unit: null,
    city: "Springfield",
    state: "OH",
    zip: "45501-1788",
  },
  "HAMLIN BANK & TRUST CO": {
    name: "HAMLIN BANK & TRUST CO",
    streetAddress: "333 W Main St",
    unit: "Po Box 367",
    city: "Smethport",
    state: "PA",
    zip: "16749",
  },
  "HOME BANK ISAOA ATIMA": {
    name: "HOME BANK ISAOA ATIMA",
    streetAddress: "P.o. Box 5474",
    unit: null,
    city: "Norwell",
    state: "MA",
    zip: "2061",
  },
  "HOME POINT ISAOA, ATIMA": {
    name: "HOME POINT ISAOA, ATIMA",
    streetAddress: "Po Box 100576",
    unit: null,
    city: "Florence",
    state: "SC",
    zip: "29502",
  },
  "HOMEBRIDGE FINANCIAL SERVICES INC C/O CENTRAL LOAN ADMIN & RPTG": {
    name: "HOMEBRIDGE FINANCIAL SERVICES INC C/O CENTRAL LOAN ADMIN & RPTG",
    streetAddress: "Po Box 202028",
    unit: null,
    city: "Florence",
    state: "SC",
    zip: "295022028",
  },
  "HOMEOWNERS FINANCIAL GROUP": {
    name: "HOMEOWNERS FINANCIAL GROUP",
    streetAddress: "16427 N Scottsdale Rd Ste 145",
    unit: null,
    city: "Scottsdale",
    state: "AZ",
    zip: "85254",
  },
  "HOMETOWN LENDERS LLC": {
    name: "HOMETOWN LENDERS LLC",
    streetAddress: "350 The Bridge St Ste 200",
    unit: null,
    city: "Huntsville",
    state: "AL",
    zip: "35806",
  },
  "IBERIA SAVINGS BANK": {
    name: "IBERIA SAVINGS BANK",
    streetAddress: "Po Box 12440",
    unit: null,
    city: "New Iberia",
    state: "LA",
    zip: "705622440",
  },
  "INVESTAR BANK (FORMERLY FIRST COMMUNITY BANK)": {
    name: "INVESTAR BANK (FORMERLY FIRST COMMUNITY BANK)",
    streetAddress: "10500 Coursey Blvd",
    unit: null,
    city: "Baton Rouge",
    state: "LA",
    zip: "70816",
  },
  "JAMES B. NUTTER & COMPANY": {
    name: "JAMES B. NUTTER & COMPANY",
    streetAddress: "4153 Broadway St",
    unit: null,
    city: "Kansas city",
    state: "MO",
    zip: "64111",
  },
  "JNJN ASSOCIATES": {
    name: "JNJN ASSOCIATES",
    streetAddress: "Po Box 492237",
    unit: null,
    city: "Los Angeles",
    state: "CA",
    zip: "900498237",
  },
  "JP MORGAN CHASE BANK": {
    name: "JP MORGAN CHASE BANK",
    streetAddress: "Po Box 47020",
    unit: null,
    city: "Doraville",
    state: "GA",
    zip: "30362",
  },
  "JP MORGAN CHASE BANK NA": {
    name: "JP MORGAN CHASE BANK NA",
    streetAddress: "Po Box 100564",
    unit: null,
    city: "Florence",
    state: "SC",
    zip: "295020564",
  },
  "JPMORGAN CHASE BANK, N.A. ISAOA/ATIMA": {
    name: "JPMORGAN CHASE BANK, N.A. ISAOA/ATIMA",
    streetAddress: "Po Box 4465",
    unit: null,
    city: "Springfield",
    state: "OH",
    zip: "45501",
  },
  "JUSTICE FEDERAL CREDIT UNION ITS SUCCESSORS AND/OR ASSIGNS": {
    name: "JUSTICE FEDERAL CREDIT UNION ITS SUCCESSORS AND/OR ASSIGNS",
    streetAddress: "5175 Parkstone Drive  St 200",
    unit: null,
    city: "Chantilly",
    state: "VA",
    zip: "201513816",
  },
  "KEY BANK NATIONAL ASSOCIATION": {
    name: "KEY BANK NATIONAL ASSOCIATION",
    streetAddress: "Po Box 6899",
    unit: null,
    city: "Cleveland",
    state: "OH",
    zip: "44101",
  },
  "LAKEVIEW LOAN SERVICING, LLC": {
    name: "LAKEVIEW LOAN SERVICING, LLC",
    streetAddress: "Po Box 202049",
    unit: null,
    city: "Florence",
    state: "SC",
    zip: "29502",
  },
  "LAKEVIEW LOAN SERVICING, LLC C/O LOANCARE, LLC ISAOA/ATIMA": {
    name: "LAKEVIEW LOAN SERVICING, LLC C/O LOANCARE, LLC ISAOA/ATIMA",
    streetAddress: "PO Box 202049",
    unit: null,
    city: "Florence",
    state: "SC",
    zip: "29502",
  },
  "LAKEVIEW LOAN SERVICING, LLC C/O M&T BANK ITS SUCCESSORS AND/OR ASSIGNS": {
    name: "LAKEVIEW LOAN SERVICING, LLC C/O M&T BANK ITS SUCCESSORS AND/OR ASSIGNS",
    streetAddress: "PO Box 5738",
    unit: null,
    city: "Springfield",
    state: "OH",
    zip: "45501",
  },
  "LAND HOME FINANCIAL SERVICES, INC. ISAOA/ATIMA": {
    name: "LAND HOME FINANCIAL SERVICES, INC. ISAOA/ATIMA",
    streetAddress: "328 2nd Street SW",
    unit: null,
    city: "Hamilton",
    state: "AL",
    zip: "35570",
  },
  "LAND HOME FINANCIAL SERVICES, INC., ISAOA": {
    name: "LAND HOME FINANCIAL SERVICES, INC., ISAOA",
    streetAddress: "c/o Dovenmuehle Mortgage, PO Box 961292",
    unit: null,
    city: "Fort Worth",
    state: "TX",
    zip: "76161-0292",
  },
  "LEADER MORTGAGE - U S BANK, NA": {
    name: "LEADER MORTGAGE - U S BANK, NA",
    streetAddress: "Po Box 7298",
    unit: null,
    city: "Springfield",
    state: "OH",
    zip: "45501",
  },
  "LEGACY HOUSING LTD": {
    name: "LEGACY HOUSING LTD",
    streetAddress: "P.o. Box 164001",
    unit: null,
    city: "Fort Worth",
    state: "TX",
    zip: "76161",
  },
  "LHFS AFFORDABLE HOUSING DIVISION": {
    name: "LHFS AFFORDABLE HOUSING DIVISION",
    streetAddress: "328 2nd Street SW",
    unit: null,
    city: "Hamilton",
    state: "AL",
    zip: "35570",
  },
  "LOAN DEPOT.COM,LLC": {
    name: "LOAN DEPOT.COM,LLC",
    streetAddress: "Po Box 7114",
    unit: null,
    city: "Troy",
    state: "MI",
    zip: "480077114",
  },
  LOANCARE: {
    name: "LOANCARE",
    streetAddress: "Po Box 202049",
    unit: null,
    city: "Florence",
    state: "SC",
    zip: "29502",
  },
  "LOANCARE, LLC ISAOA/ATIMA C/O LOANCARE, LLC": {
    name: "LOANCARE, LLC ISAOA/ATIMA C/O LOANCARE, LLC",
    streetAddress: "PO Box 202049",
    unit: null,
    city: "Florence",
    state: "SC",
    zip: "29502",
  },
  "LOANDEPOT COM LLC": {
    name: "LOANDEPOT COM LLC",
    streetAddress: "Po Box 202028",
    unit: null,
    city: "Florence",
    state: "SC",
    zip: "29502",
  },
  "LOANDEPOT.COM, LLC / C/O CENTRAL LOAN ADMIN & REPORTING": {
    name: "LOANDEPOT.COM, LLC / C/O CENTRAL LOAN ADMIN & REPORTING",
    streetAddress: "Po Box 202028",
    unit: null,
    city: "Florence",
    state: "SC",
    zip: "29502",
  },
  "M&T BANK ISAOA": {
    name: "M&T BANK ISAOA",
    streetAddress: "PO Box 5738",
    unit: null,
    city: "Springfield",
    state: "OH",
    zip: "45501",
  },
  "M&T MORTGAGE": {
    name: "M&T MORTGAGE",
    streetAddress: "Po Box 5738",
    unit: null,
    city: "Springfield",
    state: "OH",
    zip: "45501",
  },
  "MIDLAND MORTGAGE A DIVISION OF MIDFIRST BANK ISAOA": {
    name: "MIDLAND MORTGAGE A DIVISION OF MIDFIRST BANK ISAOA",
    streetAddress: "Po Box 163529",
    unit: null,
    city: "Fort Worth",
    state: "TX",
    zip: "761613529",
  },
  "MIDWEST LOAN SERVICES": {
    name: "MIDWEST LOAN SERVICES",
    streetAddress: "Po Box 39159",
    unit: null,
    city: "Solon",
    state: "OH",
    zip: "441390159",
  },
  "MOBILE HOME FUNDING LLC": {
    name: "MOBILE HOME FUNDING LLC",
    streetAddress: "1080 Pittsford Victor Rd Ste 202",
    unit: null,
    city: "Pittsford",
    state: "NY",
    zip: "145343805",
  },
  "MOUNT VERNON BANK": {
    name: "MOUNT VERNON BANK",
    streetAddress: "2109 E 1st St",
    unit: null,
    city: "Vidalia",
    state: "GA",
    zip: "30474",
  },
  "MOVEMENT MORTGAGE, LLC ISAO/ATIMA": {
    name: "MOVEMENT MORTGAGE, LLC ISAO/ATIMA",
    streetAddress: "8024 Calvin Hall Road",
    unit: null,
    city: "Indian Land",
    state: "SC",
    zip: "29707",
  },
  "MR COOPER": {
    name: "MR COOPER",
    streetAddress: "Po Box 7729",
    unit: null,
    city: "Springfield",
    state: "OH",
    zip: "45501",
  },
  "NATIONS LENDING CORP ISAOA/ATIMA": {
    name: "NATIONS LENDING CORP ISAOA/ATIMA",
    streetAddress: "4 Summit Park Dr Ste 200",
    unit: null,
    city: "Independence",
    state: "OH",
    zip: "44131",
  },
  "NATIONS LENDING CORPORATION ISAOA/ATIMA": {
    name: "NATIONS LENDING CORPORATION ISAOA/ATIMA",
    streetAddress: "4 Summit Park Drive Suite 200",
    unit: null,
    city: "Independence",
    state: "OH",
    zip: "44131",
  },
  "NATIONSTAR MORTGAGE LLC ITS SUCCESSORS AND/OR ASSIGNS ISAOA-ATIMA": {
    name: "NATIONSTAR MORTGAGE LLC ITS SUCCESSORS AND/OR ASSIGNS ISAOA-ATIMA",
    streetAddress: "PO Box 7729",
    unit: null,
    city: "Springfield",
    state: "OH",
    zip: "45501",
  },
  "NATIONSTAR MORTGAGE, LLC ITS SUCCESSORSS &/OR ASSIGN": {
    name: "NATIONSTAR MORTGAGE, LLC ITS SUCCESSORSS &/OR ASSIGN",
    streetAddress: "Po Box 7729",
    unit: null,
    city: "Springfield",
    state: "OH",
    zip: "454017729",
  },
  "NAVY FEDERAL CREDIT UNION ISAOA": {
    name: "NAVY FEDERAL CREDIT UNION ISAOA",
    streetAddress: "Po Box 100598",
    unit: null,
    city: "Florence",
    state: "SC",
    zip: "29502",
  },
  "NBT BANK ITS SUCCESSORSS &/OR ASSIGN": {
    name: "NBT BANK ITS SUCCESSORSS &/OR ASSIGN",
    streetAddress: "20 Mohawk St.",
    unit: null,
    city: "Canajoharie",
    state: "NY",
    zip: "13317",
  },
  "NEWREZ LLC": {
    name: "NEWREZ LLC",
    streetAddress: "Po Box 7050",
    unit: null,
    city: "Troy",
    state: "MI",
    zip: "48007",
  },
  "NEWREZ LLC ISAOA/ATIMA": {
    name: "NEWREZ LLC ISAOA/ATIMA",
    streetAddress: "PO Box 7050",
    unit: null,
    city: "Troy",
    state: "MI",
    zip: "48007",
  },
  "NORMANGEE STATE BANK": {
    name: "NORMANGEE STATE BANK",
    streetAddress: "Po Box 189",
    unit: null,
    city: "Normangee",
    state: "TX",
    zip: "778710189",
  },
  "NORTH COUNTRY SAVINGS BANK": {
    name: "NORTH COUNTRY SAVINGS BANK",
    streetAddress: "Po Box 150",
    unit: null,
    city: "Northville",
    state: "NY",
    zip: "12134",
  },
  "NORTHPOINTE BANK ISAOA / ATIMA": {
    name: "NORTHPOINTE BANK ISAOA / ATIMA",
    streetAddress: "P.o. Box 7111",
    unit: null,
    city: "Troy",
    state: "MI",
    zip: "480077111",
  },
  "NORTHUMBERLAND NAT L BANK": {
    name: "NORTHUMBERLAND NAT L BANK",
    streetAddress: "245 Front Street",
    unit: null,
    city: "Northumberland",
    state: "PA",
    zip: "17857",
  },
  "NOVA FINANCIAL & CORP": {
    name: "NOVA FINANCIAL & CORP",
    streetAddress: "6245 E Broadway Blvd Ste 400",
    unit: null,
    city: "Tucson",
    state: "AZ",
    zip: "857114029",
  },
  "NOVA FINANCIAL & INVESTMENT CORP. DBA NOVA HOME LOANS": {
    name: "NOVA FINANCIAL & INVESTMENT CORP. DBA NOVA HOME LOANS",
    streetAddress: "Po Box 202049",
    unit: null,
    city: "Florence",
    state: "SC",
    zip: "29502",
  },
  "OCWEN LOAN SERVICING": {
    name: "OCWEN LOAN SERVICING",
    streetAddress: "Po Box 6723",
    unit: null,
    city: "Springfield",
    state: "OH",
    zip: "45501",
  },
  "OCWEN LOAN SERVICING LLC ISAOA ATIMA": {
    name: "OCWEN LOAN SERVICING LLC ISAOA ATIMA",
    streetAddress: "Po Box 659826",
    unit: null,
    city: "San Antonio",
    state: "TX",
    zip: "782659126",
  },
  "OHIO VALLEY BANK": {
    name: "OHIO VALLEY BANK",
    streetAddress: "Po Box 240",
    unit: null,
    city: "Gallipolis",
    state: "OH",
    zip: "45631",
  },
  "OMEGA BANK N A": {
    name: "OMEGA BANK N A",
    streetAddress: "P O Box 298",
    unit: null,
    city: "state College",
    state: "PA",
    zip: "16804",
  },
  "ON Q FINANCIAL, INC.": {
    name: "ON Q FINANCIAL, INC.",
    streetAddress: "Po Box 961292",
    unit: null,
    city: "Fort Worth",
    state: "TX",
    zip: "76161-029",
  },
  "ONEAZ CREDIT UNION": {
    name: "ONEAZ CREDIT UNION",
    streetAddress: "Po Box 961292",
    unit: null,
    city: "Fort Worth",
    state: "TX",
    zip: "761610292",
  },
  "ONITY MORTGAGE CORPORATION FKA PHH MORTGAGE SERVICES": {
    name: "ONITY MORTGAGE CORPORATION FKA PHH MORTGAGE SERVICES",
    streetAddress: "PO Box 5954",
    unit: null,
    city: "Springfield",
    state: "OH",
    zip: "45501",
  },
  "ONITY MORTGAGE CORPORATION ISAOA/ATIMA": {
    name: "ONITY MORTGAGE CORPORATION ISAOA/ATIMA",
    streetAddress: "PO Box 5954",
    unit: null,
    city: "Springfield",
    state: "OH",
    zip: "45501",
  },
  "ORIGIN BANK": {
    name: "ORIGIN BANK",
    streetAddress: "2501 Research Forest Dr #A",
    unit: null,
    city: "The Woodlands",
    state: "TX",
    zip: "77381",
  },
  "PARAMOUNT RES MTGE GRP": {
    name: "PARAMOUNT RES MTGE GRP",
    streetAddress: "1265 Corona Pointe Ct Ste 301",
    unit: null,
    city: "Corona",
    state: "CA",
    zip: "928791799",
  },
  "PBT BANCORP": {
    name: "PBT BANCORP",
    streetAddress: "PO Box 989",
    unit: null,
    city: "Hazard",
    state: "KY",
    zip: "41702",
  },
  "PELICAN STATE CREDIT UNION": {
    name: "PELICAN STATE CREDIT UNION",
    streetAddress: "P.o. Box 40088",
    unit: null,
    city: "Baton Rouge",
    state: "LA",
    zip: "70835",
  },
  "PENDLETON COMMUNITY BANK": {
    name: "PENDLETON COMMUNITY BANK",
    streetAddress: "Po Box 487",
    unit: null,
    city: "Franklin",
    state: "WV",
    zip: "26807",
  },
  "PENNIAN BANK": {
    name: "PENNIAN BANK",
    streetAddress: "P.o. Box 96",
    unit: null,
    city: "Mifflintown",
    state: "PA",
    zip: "17059",
  },
  "PENNYMAC LOAN SERVICES LLC ISAOA": {
    name: "PENNYMAC LOAN SERVICES LLC ISAOA",
    streetAddress: "Po Box 6618",
    unit: null,
    city: "Springfield",
    state: "OH",
    zip: "455016618",
  },
  "PEOPLES BANK": {
    name: "PEOPLES BANK",
    streetAddress: "Po Box 738",
    unit: null,
    city: "Marietta",
    state: "OH",
    zip: "45750",
  },
  "PERFORMANCE EQUITY PARTNERS INC": {
    name: "PERFORMANCE EQUITY PARTNERS INC",
    streetAddress: "Po Box 368",
    unit: null,
    city: "Tinsley Park",
    state: "IL",
    zip: "60477",
  },
  "PHH MORTGAGE SERVICES ISAOA": {
    name: "PHH MORTGAGE SERVICES ISAOA",
    streetAddress: "Po Box 5954",
    unit: null,
    city: "Springfield",
    state: "OH",
    zip: "45501",
  },
  "PIONEER COMMUNITY BANK": {
    name: "PIONEER COMMUNITY BANK",
    streetAddress: "P.o. Box 368",
    unit: null,
    city: "Iaeger",
    state: "WV",
    zip: "24844",
  },
  "PIONEER TITLE AGENCY": {
    name: "PIONEER TITLE AGENCY",
    streetAddress: "580 E Wilcox Dr",
    unit: null,
    city: "Sierra Vista",
    state: "AZ",
    zip: "856352532",
  },
  "PLANET HOME LENDING, LLC ISAOA/ATIMA": {
    name: "PLANET HOME LENDING, LLC ISAOA/ATIMA",
    streetAddress: "P.o. Box 5023",
    unit: null,
    city: "Troy",
    state: "MI",
    zip: "480075023",
  },
  "PLAZA HOME MORTGAGE": {
    name: "PLAZA HOME MORTGAGE",
    streetAddress: "Po Box 5954",
    unit: null,
    city: "Springfield",
    state: "OH",
    zip: "455015954",
  },
  "PNC BANK": {
    name: "PNC BANK",
    streetAddress: "Consumer Loan Center",
    unit: "2730 Liberty Avenue",
    city: "Pittsburgh",
    state: "PA",
    zip: "15222",
  },
  "PNC MORTGAGE A DIVISION OF PNC BANK NA": {
    name: "PNC MORTGAGE A DIVISION OF PNC BANK NA",
    streetAddress: "Po Box 7433",
    unit: null,
    city: "Springfield",
    state: "OH",
    zip: "455017433",
  },
  "POCA VALLEY BANK": {
    name: "POCA VALLEY BANK",
    streetAddress: "Po Box 56",
    unit: null,
    city: "Walton",
    state: "WV",
    zip: "25286",
  },
  "PORCHPASS INC. ISAOA/ATIMA": {
    name: "PORCHPASS INC. ISAOA/ATIMA",
    streetAddress: "PO Box 690748",
    unit: null,
    city: "San Antonio",
    state: "TX",
    zip: "78269",
  },
  PRIMELENDING: {
    name: "PRIMELENDING",
    streetAddress: "Po Box 202028",
    unit: null,
    city: "Florence",
    state: "SC",
    zip: "29502",
  },
  "RED CROWN FEDERAL CREDIT UNION ISAOA/ATIMA": {
    name: "RED CROWN FEDERAL CREDIT UNION ISAOA/ATIMA",
    streetAddress: "PO Box 39517",
    unit: null,
    city: "Solon",
    state: "OH",
    zip: "44139",
  },
  "RED RIVER EMPLOYEES FCU": {
    name: "RED RIVER EMPLOYEES FCU",
    streetAddress: "Po Box 5909",
    unit: null,
    city: "Texarkana",
    state: "TX",
    zip: "755055909",
  },
  "RELIANT BANK": {
    name: "RELIANT BANK",
    streetAddress: "170 Market Place Blvd",
    unit: null,
    city: "Knoxville",
    state: "TN",
    zip: "379222337",
  },
  "REVERSE MORTGAGE SOLUTIONS": {
    name: "REVERSE MORTGAGE SOLUTIONS",
    streetAddress: "Po Box 39457",
    unit: null,
    city: "Solon",
    state: "OH",
    zip: "441390218",
  },
  "RIVERVIEW BANK": {
    name: "RIVERVIEW BANK",
    streetAddress: "11 N 2nd St",
    unit: "Po Box 171",
    city: "Clearfield",
    state: "PA",
    zip: "16830",
  },
  "ROCKET MORTGAGE, LLC ISAOA (FLORENCE, SC)": {
    name: "ROCKET MORTGAGE, LLC ISAOA",
    streetAddress: "Po Box 202070",
    unit: null,
    city: "Florence",
    state: "SC",
    zip: "29502",
  },
  "ROCKET MORTGAGE, LLC ISAOA (SPRINGFIELD, OH)": {
    name: "ROCKET MORTGAGE, LLC ISAOA",
    streetAddress: "PO Box 7729",
    unit: null,
    city: "Springfield",
    state: "OH",
    zip: "45501",
  },
  "ROCKET MORTGAGE, LLC ITS SUCCESSORS AND/OR ASSIGNS": {
    name: "ROCKET MORTGAGE, LLC ITS SUCCESSORS AND/OR ASSIGNS",
    streetAddress: "PO Box 7729",
    unit: null,
    city: "Springfield",
    state: "OH",
    zip: "45501",
  },
  "ROUNDPOINT MORTGAGE SERVICING CORP": {
    name: "ROUNDPOINT MORTGAGE SERVICING CORP",
    streetAddress: "Po Box 2927",
    unit: null,
    city: "Phoenix",
    state: "AZ",
    zip: "850622927",
  },
  "ROUNDPOINT MORTGAGE SERVICING LLC ISAOA/ ATIMA": {
    name: "ROUNDPOINT MORTGAGE SERVICING LLC ISAOA/ ATIMA",
    streetAddress: "PO Box 10210",
    unit: null,
    city: "Daytona Beach",
    state: "FL",
    zip: "32120",
  },
  "RUSHMORE LOAN MANAGEMENT": {
    name: "RUSHMORE LOAN MANAGEMENT",
    streetAddress: "Po Box 692409",
    unit: null,
    city: "San Antonio",
    state: "TX",
    zip: "78269",
  },
  "SANTANDER BANK": {
    name: "SANTANDER BANK",
    streetAddress: "Po Box 961292",
    unit: null,
    city: "Fort Worth",
    state: "TX",
    zip: "75161",
  },
  "SB INDEMNITY PROGRAM": {
    name: "SB INDEMNITY PROGRAM",
    streetAddress: "PO Box 600116",
    unit: null,
    city: "Dallas",
    state: "TX",
    zip: "75360",
  },
  "SEACOMM FEDERAL CREDIT UNION": {
    name: "SEACOMM FEDERAL CREDIT UNION",
    streetAddress: "30 Stearns Street",
    unit: null,
    city: "Massena",
    state: "NY",
    zip: "13662",
  },
  "SECURITY STATE BANK": {
    name: "SECURITY STATE BANK",
    streetAddress: "Po Box S",
    unit: null,
    city: "Pearsall",
    state: "TX",
    zip: "78061",
  },
  "SELECT PORTFOLIO SERVICING INC ISAOA": {
    name: "SELECT PORTFOLIO SERVICING INC ISAOA",
    streetAddress: "Po Box 7277",
    unit: null,
    city: "Springfield",
    state: "OH",
    zip: "45501",
  },
  "SELENE FINANCE": {
    name: "SELENE FINANCE",
    streetAddress: "Po Box 461470",
    unit: null,
    city: "San Antonio",
    state: "TX",
    zip: "782461470",
  },
  "SERVICE MAC LLC, ACTING ON BEHALF OF FAIRWAY ATTN: INSURANCE DEPARTMENT ISAOA/ATIMA":
    {
      name: "SERVICE MAC LLC, ACTING ON BEHALF OF FAIRWAY ATTN: INSURANCE DEPARTMENT ISAOA/ATIMA",
      streetAddress: "PO Box 29411",
      unit: null,
      city: "Phoenix",
      state: "AZ",
      zip: "85038",
    },
  "SERVICEMAC MORTGAGE ISAOA ATIMA": {
    name: "SERVICEMAC MORTGAGE ISAOA ATIMA",
    streetAddress: "Po Box 29411",
    unit: null,
    city: "Phoenix",
    state: "AZ",
    zip: "850389411",
  },
  "SERVICEMAC, LLC ACTING ON BEHALF OF FAIRWAY": {
    name: "SERVICEMAC, LLC ACTING ON BEHALF OF FAIRWAY",
    streetAddress: "PO Box 29411",
    unit: null,
    city: "Phoenix",
    state: "AZ",
    zip: "85038",
  },
  "SERVU FEDERAL CREDIT UNION ITS SUCCESSORSS &/OR ASSIGN": {
    name: "SERVU FEDERAL CREDIT UNION ITS SUCCESSORSS &/OR ASSIGN",
    streetAddress: "9823 Science Center Dr",
    unit: null,
    city: "Painted Post",
    state: "NY",
    zip: "14870",
  },
  "SHELLPOINT MORTGAGE SERVICING ISAOA / ATIMA": {
    name: "SHELLPOINT MORTGAGE SERVICING ISAOA / ATIMA",
    streetAddress: "P.o. Box 7050",
    unit: null,
    city: "Troy",
    state: "MI",
    zip: "48007",
  },
  "SHELTER HOMES LLC": {
    name: "SHELTER HOMES LLC",
    streetAddress: "7555 N Oracle Rd",
    unit: null,
    city: "Tucson",
    state: "AZ",
    zip: "85704",
  },
  "SIMMONS FIRST NATL BANK": {
    name: "SIMMONS FIRST NATL BANK",
    streetAddress: "Po Box 7009",
    unit: null,
    city: "Pine Bluff",
    state: "AR",
    zip: "716117009",
  },
  "SOMERSET TRUST COMPANY": {
    name: "SOMERSET TRUST COMPANY",
    streetAddress: "P O Box 1192",
    unit: null,
    city: "Somerset",
    state: "PA",
    zip: "15501",
  },
  "SPECIALIZED LOAN SERVICING": {
    name: "SPECIALIZED LOAN SERVICING",
    streetAddress: "Po Box 620188",
    unit: null,
    city: "Atlanta",
    state: "GA",
    zip: "30362",
  },
  "ST LANDRY HOMESTEAD FEDERAL SAVINGS BANK": {
    name: "ST LANDRY HOMESTEAD FEDERAL SAVINGS BANK",
    streetAddress: "Po Box 1909",
    unit: null,
    city: "Opelousas",
    state: "LA",
    zip: "705711909",
  },
  "STATE EMPLOYEES' CREDIT UNION": {
    name: "STATE EMPLOYEES' CREDIT UNION",
    streetAddress: "Po Box 25279",
    unit: null,
    city: "Raleigh",
    state: "NC",
    zip: "25279",
  },
  "SUMMIT COMMUNITY BANK": {
    name: "SUMMIT COMMUNITY BANK",
    streetAddress: "Po Box 680",
    unit: null,
    city: "Moorefield",
    state: "WV",
    zip: "26836",
  },
  "SUMMIT FUNDING INC": {
    name: "SUMMIT FUNDING INC",
    streetAddress: "Po Box 1194",
    unit: null,
    city: "Springfield",
    state: "OH",
    zip: "455011194",
  },
  "SUN AMERICAN MORTGAGE COMP.": {
    name: "SUN AMERICAN MORTGAGE COMP.",
    streetAddress: "4140 E Baseline Rd",
    unit: "Ste 206",
    city: "Mesa",
    state: "AZ",
    zip: "852064415",
  },
  "SUN WEST MORTGAGE CO INC ITS SUCCESSORS AND/OR ASSIGNS": {
    name: "SUN WEST MORTGAGE CO INC ITS SUCCESSORS AND/OR ASSIGNS",
    streetAddress: "P.o. Box 7083",
    unit: null,
    city: "Troy",
    state: "MI",
    zip: "48007",
  },
  "SUPERIOR CHOICE CU": {
    name: "SUPERIOR CHOICE CU",
    streetAddress: "Po Box 924265",
    unit: null,
    city: "Fort Worth",
    state: "TX",
    zip: "761244265",
  },
  "SUPERIOR NATIONAL BANK": {
    name: "SUPERIOR NATIONAL BANK",
    streetAddress: "Po Box 450",
    unit: null,
    city: "Hancock",
    state: "MI",
    zip: "49930",
  },
  "SWSF DBA CASCADE FINANCIAL": {
    name: "SWSF DBA CASCADE FINANCIAL",
    streetAddress: "Po Box 792187",
    unit: null,
    city: "San Antonio",
    state: "TX",
    zip: "782792187",
  },
  "TAMMAC HOLDINGS CORP, DBA AUTOMHATIC FINANCIAL ISAOA/ATIMA": {
    name: "TAMMAC HOLDINGS CORP, DBA AUTOMHATIC FINANCIAL ISAOA/ATIMA",
    streetAddress: "PO BOX 1249",
    unit: null,
    city: "Coppell",
    state: "TX",
    zip: "75019",
  },
  "TD BANK, N.A.": {
    name: "TD BANK, N.A.",
    streetAddress: "Po Box 39158",
    unit: null,
    city: "Solon",
    state: "OH",
    zip: "44139",
  },
  THDA: {
    name: "THDA",
    streetAddress: "502 Deadrick 3rd Floor",
    unit: null,
    city: "Nashville",
    state: "TN",
    zip: "37243",
  },
  "THE EVANGELINE BANK & TRUST": {
    name: "THE EVANGELINE BANK & TRUST",
    streetAddress: "Po Box 863329",
    unit: null,
    city: "Plano",
    state: "TX",
    zip: "75086",
  },
  "THE FOOTHILLS BANK": {
    name: "THE FOOTHILLS BANK",
    streetAddress: "2285 S 4th Ave",
    unit: null,
    city: "Yuma",
    state: "AZ",
    zip: "85364",
  },
  "THE HUNTINGTON NATIONAL BANK": {
    name: "THE HUNTINGTON NATIONAL BANK",
    streetAddress: "Po Box 5072",
    unit: null,
    city: "Troy",
    state: "MI",
    zip: "480075072",
  },
  "THE MONEY SOURCE": {
    name: "THE MONEY SOURCE",
    streetAddress: "Po Box 1194",
    unit: null,
    city: "Springfield",
    state: "OH",
    zip: "45501",
  },
  "TRIAD FINANCIAL SERVICES, INC": {
    name: "TRIAD FINANCIAL SERVICES, INC",
    streetAddress: "13901 S Sutton Park Drive",
    unit: "Bldg A Suite 220",
    city: "Jacksonville",
    state: "FL",
    zip: "32224",
  },
  "TWIN LAKES HOME INC": {
    name: "TWIN LAKES HOME INC",
    streetAddress: "P.o. Box 659",
    unit: null,
    city: "Yorkshire",
    state: "NY",
    zip: "14173",
  },
  "U.S. SMALL BUSINESS ADMINISTRATION": {
    name: "U.S. SMALL BUSINESS ADMINISTRATION",
    streetAddress: "10737 Gateway Blvd W Ste 300",
    unit: null,
    city: "El Paso",
    state: "TX",
    zip: "799354910",
  },
  "UNION HOME MORTGAGE CORP": {
    name: "UNION HOME MORTGAGE CORP",
    streetAddress: "Po Box 202028",
    unit: null,
    city: "Florence",
    state: "WV",
    zip: "29502",
  },
  "UNISON BANK": {
    name: "UNISON BANK",
    streetAddress: "1835 E Pecos Rd",
    unit: null,
    city: "Gilbert",
    state: "AZ",
    zip: "85295",
  },
  "UNITED BANK": {
    name: "UNITED BANK",
    streetAddress: "Po Box 189",
    unit: null,
    city: "Dunbar",
    state: "WV",
    zip: "25064",
  },
  "UNITED WHOLESALE MORTGAGE": {
    name: "UNITED WHOLESALE MORTGAGE",
    streetAddress: "Po Box 202028",
    unit: null,
    city: "Florence",
    state: "SC",
    zip: "29502",
  },
  "UNITED WHOLESALE MORTGAGE ISAOA/ATIMA": {
    name: "UNITED WHOLESALE MORTGAGE ISAOA/ATIMA",
    streetAddress: "PO Box 202175",
    unit: null,
    city: "Florence",
    state: "SC",
    zip: "29502",
  },
  "US BANK": {
    name: "US BANK",
    streetAddress: "Po Box 1551",
    unit: null,
    city: "Springfield",
    state: "OH",
    zip: "455011551",
  },
  "US BANK NA C/O US BANK HOME MORTGAGE": {
    name: "US BANK NA C/O US BANK HOME MORTGAGE",
    streetAddress: "Po Box 961045",
    unit: null,
    city: "Ft Worth",
    state: "TX",
    zip: "76161",
  },
  "US MORTGAGE CORPORATION": {
    name: "US MORTGAGE CORPORATION",
    streetAddress: "201 Old County Rd Ste 140",
    unit: null,
    city: "Melville",
    state: "NY",
    zip: "11747",
  },
  "USDA ACTING THROUGH TRHS": {
    name: "USDA ACTING THROUGH TRHS",
    streetAddress: "Po Box 66876",
    unit: null,
    city: "Saint Louis",
    state: "MO",
    zip: "63166",
  },
  "VANDERBILT MORTGAGE COMPANY": {
    name: "VANDERBILT MORTGAGE COMPANY",
    streetAddress: "Po Box 9800",
    unit: null,
    city: "Maryville",
    state: "TN",
    zip: "37802",
  },
  "VILLAGE CAPITAL & INVESTMENT": {
    name: "VILLAGE CAPITAL & INVESTMENT",
    streetAddress: "Po Box 29217",
    unit: null,
    city: "Phoenix",
    state: "AZ",
    zip: "85038",
  },
  "VILLAGE CAPITAL & INVESTMENT LLC ISAOA/ATIMA": {
    name: "VILLAGE CAPITAL & INVESTMENT LLC ISAOA/ATIMA",
    streetAddress: "PO Box 29217",
    unit: null,
    city: "Phoenix",
    state: "AZ",
    zip: "85038",
  },
  "VYSTAR CREDIT UNION ISAOA": {
    name: "VYSTAR CREDIT UNION ISAOA",
    streetAddress: "PO Box 1944",
    unit: null,
    city: "Carmel",
    state: "IN",
    zip: "46082",
  },
  "WASHINGTON FEDERAL BANK IT'S SUCCESSORS AND/OR ASSIGNS": {
    name: "WASHINGTON FEDERAL BANK IT'S SUCCESSORS AND/OR ASSIGNS",
    streetAddress: "425 Pike St",
    unit: null,
    city: "Seattle",
    state: "WA",
    zip: "981012399",
  },
  "WELLS FARGO BANK  NA #936": {
    name: "WELLS FARGO BANK  NA #936",
    streetAddress: "Po Box 100515",
    unit: null,
    city: "Florence",
    state: "SC",
    zip: "29502",
  },
  WESBANCO: {
    name: "WESBANCO",
    streetAddress: "1 Bank Plaza",
    unit: null,
    city: "Wheeling",
    state: "WV",
    zip: "26003",
  },
  "WEST VIRGINIA HOUSING DEVELOP. FUND": {
    name: "WEST VIRGINIA HOUSING DEVELOP. FUND",
    streetAddress: "5710 Maccorkle Ave Se",
    unit: null,
    city: "Charleston",
    state: "WV",
    zip: "25304",
  },
  "WESTSTAR MORTGAGE CORP": {
    name: "WESTSTAR MORTGAGE CORP",
    streetAddress: "2155 Louisiana Blvd Ne Ste 8000",
    unit: null,
    city: "Albuquerque",
    state: "NM",
    zip: "871105483",
  },
  "WHITESVILLE STATE BANK": {
    name: "WHITESVILLE STATE BANK",
    streetAddress: "Po Box 68",
    unit: null,
    city: "Whitesville",
    state: "WV",
    zip: "252090068",
  },
  "ZIONS BANK": {
    name: "ZIONS BANK",
    streetAddress: "Po Box 25007",
    unit: null,
    city: "Salt Lake city",
    state: "UT",
    zip: "84125",
  },
};

export const lendersOptions = Object.keys(lenders).map<OptionType>(
  (lender) => ({ label: lender, value: lender })
);

/** The lender name to save for a dropdown label; custom names pass through. */
export const getLenderName = (label: string) => lenders[label]?.name ?? label;
